import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "./gallery.scss";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface GalleryProps {
    images: string[];
}

const Gallery: React.FC<GalleryProps> = ({ images }) => {
    return (
        <>
            <Swiper
                modules={[Pagination, Autoplay]}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                pagination={{ el: ".pag-wrapper" }}
                id="gallery"                
                slidesPerView={1}
                loop={true}
            >
             
                {images.map((image, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className="image-wrapper"
                            style={{ backgroundImage: `url(${image})` }}
                        />
                    </SwiperSlide>
                ))}
                <div className="pag-wrapper"></div>
            </Swiper>
        </>
    );
};

export default Gallery;
